import { render, staticRenderFns } from "./StaffServerTable.vue?vue&type=template&id=59a986d7"
import script from "./StaffServerTable.vue?vue&type=script&lang=js"
export * from "./StaffServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports